import { render, staticRenderFns } from "./page-create.vue?vue&type=template&id=50583772&"
import script from "./page-create.vue?vue&type=script&lang=ts&"
export * from "./page-create.vue?vue&type=script&lang=ts&"
import style0 from "./page-create.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports